import React, { useEffect } from 'react'

import styled, { keyframes } from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import Close from '@public/images/icons/close.png'

const SlideIn = keyframes`
    0% {
        transform:  translateY(300px);
        opacity: 0
    }

    100% {
        transform:  translateY(0px);
        opacity: 1
    }
`

const FadeIn = keyframes`
    0% {
        opacity: 0
    }

    100% {
        opacity: 1
    }
`

const Modal = styled.div<{ show?: boolean }>`
  display: none;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(40, 41, 40, 0.3);
  animation-name: ${FadeIn};
  animation-duration: 0.2s;

  @media (max-width: 700px) {
    display: ${props => (props.show ? 'block' : 'none')};
  }
`

const ModalBody = styled.div<{
  bodyPadBottom?: string
  modalHeight?: string
  hideHeader?: boolean
  bg?: string
  openAsPage?: boolean
}>`
  overflow: auto;
  position: fixed;
  bottom: 0;
  padding-bottom: ${props => props.bodyPadBottom || '20px'};
  border-radius: 20px 20px 0 0%;
  background: ${props => props.bg || '#fff'};
  height: ${props => props.modalHeight || '9%'};
  width: 100%;
  animation-name: ${SlideIn};
  animation-duration: 0.2s;
  ${props => (props.openAsPage ? 'border-radius:0;' : props.hideHeader && 'border-radius: 10px 10px 0 0;')};
`

const ModalContent = styled.div<{
  contentHeight?: string
  padBottom?: string
  hideHeader?: boolean
  bg?: string
  fixedHeader?: boolean
}>`
  padding-top: ${props => (props.fixedHeader ? '40px' : '0')};
  overflow: auto;
  height: ${props => props.contentHeight || '85%'};
  padding-bottom: ${props => props.padBottom || '10px'};
  -webkit-overflow-scrolling: touch;
  background: ${props => props.bg || '#fff'};
  ${props => props.hideHeader && 'border-radius: 10px 10px 0 0;'};
`

const ModalHeader = styled.div<{
  shadow?: boolean
  bg?: string
  fixedHeader?: boolean
  modalHeaderTop?: boolean
}>`
  display: grid;
  grid-template-columns: 4fr 1fr;
  height: 50px;
  padding-top: 10px;
  border-radius: 10px 10px 0 0;
  position: ${props => props.fixedHeader && 'fixed'};
  width: ${props => props.fixedHeader && '100%'};
  z-index: ${props => props.fixedHeader && '999'};
  background: ${props => props.bg || '#fff'};
  border-bottom: ${props => (props.shadow ? '1px solid rgba(0,0,0,0.1)' : 'none')};
  ${props =>
    props?.modalHeaderTop &&
    `position: relative;
    z-index: 99;
    height: 0;`}
`

const Heading = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
  color: #030f09;
  font-size: 14px;
  font-weight: 500;
`

export const CloseIcon = styled(LazyLoadImage)`
  height: 20px;
  width: 20px;
`

const CloseIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const BottomSlideModalWrapper = (props: {
  show: boolean
  className: string
  datatestid: string
  hideHeader: boolean
  modalHeight: any
  height: string
  bg?: any
  bodyPadBottom: any
  shadow?: string
  heading: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
  hideClose?: any
  closeModal: React.MouseEventHandler<HTMLImageElement>
  contentHeight: any
  padBottom: any
  openAsPage?: boolean
  fixedHeader?: boolean
  modalHeaderTop?: boolean
  children: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
}) => {
  useEffect(
    () => () => {
      document.body.style.overflow = 'auto'
    },
    []
  )
  useEffect(() => {
    document.body.style.overflow = props.show ? 'hidden' : 'auto'
  }, [props.show])
  return (
    <Modal show={props.show} className={props.className} data-testid={props?.datatestid || 'bottomslidemodal'}>
      <ModalBody
        hideHeader={props.hideHeader}
        modalHeight={props.modalHeight}
        bg={props.bg}
        bodyPadBottom={props.bodyPadBottom}
        openAsPage={props.openAsPage}>
        {!props.hideHeader && (
          <ModalHeader shadow={props.shadow} bg={props.bg} fixedHeader={props.fixedHeader}>
            <Heading>{props.heading}</Heading>
            {!props.hideClose && (
              <CloseIconWrapper>
                <CloseIcon src={Close} height="20px" width="20px" />
              </CloseIconWrapper>
            )}
          </ModalHeader>
        )}
        <ModalContent
          hideHeader={props.hideHeader}
          contentHeight={props.contentHeight}
          padBottom={props.padBottom}
          bg={props.bg}>
          {props.children}
        </ModalContent>
      </ModalBody>
    </Modal>
  )
}

export default BottomSlideModalWrapper
